export const DATA_UNITS = {
  MB: 'megabytes',
  Mbps: 'megabytes per second',
  GB: 'gigabytes'
} as const;

export const TIME_UNITS = {
  mth: 'month',
  yr: 'year'
} as const;
